import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPermissions from './permissions.reducer';
import { permissionsAdapter } from './permissions.reducer';

export const selectPermissionsState = createFeatureSelector<
  fromPermissions.PermissionsState
>(fromPermissions.permissionsFeatureKey);

export const selectLoadingTarget = createSelector(
  selectPermissionsState,
  (state) => state.loadingTarget
);

const { selectEntities } = permissionsAdapter.getSelectors();

export const selectPermissions = createSelector(
  selectPermissionsState,
  (state) => selectEntities(state)
);

export const selectPermissionsError = createSelector(
  selectPermissionsState,
  (state) => state.error
);
